import * as ua from "@tencent/docs-user-agent/pure";
import { getUserAgent } from "@tencent/docs-user-agent/lib/util";
var currentUserAgent = /* @__PURE__ */ getUserAgent();
function getRawCookies() {
  return typeof document !== "undefined" ? document.cookie : "";
}
function getCookie(key, source) {
  var _a;
  var r = new RegExp("(?:^|;+|\\s+)" + key + "=([^;]*)");
  if (source === void 0) {
    source = getRawCookies();
  }
  return (_a = source.match(r)) == null ? void 0 : _a[1];
}
function setCookie(key, val, days, path, domain) {
  if (days === void 0)
    days = 30 * 24 * 60 * 60 * 1e3;
  if (path === void 0)
    path = "/";
  if (typeof document === "undefined") {
    return;
  }
  var expires = new Date(Date.now() + 36e5 * 24 * days);
  document.cookie = key + "=" + encodeURIComponent(val) + ";expires=" + expires.toUTCString() + ";path=" + path + ";" + (domain ? "domain=" + domain + ";" : "");
}
function delCookie(key, path, domain) {
  if (typeof document === "undefined") {
    return;
  }
  document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + (path || "/") + ";" + (domain ? "domain=" + domain + ";" : "");
}
function getQuery(key, source) {
  if (source === void 0)
    source = getLocationSearch();
  var _a;
  var r = new RegExp("(\\?|&)" + key + "=([^&]*)(#|&|$)");
  var val = (_a = source.match(r)) == null ? void 0 : _a[2];
  return val === void 0 ? val : decodeURIComponent(val);
}
function getXSRF() {
  return getCookie("TOK");
}
function getLocationSearch() {
  if (typeof location === "undefined") {
    return "";
  }
  return location.search;
}
function getRuntimeConfig() {
  var _a, _b;
  return (_b = (_a = window.AppConfig) == null ? void 0 : _a.normal) == null ? void 0 : _b.runtime;
}
function getNormalConfig() {
  var _a;
  return (_a = window.AppConfig) == null ? void 0 : _a.normal;
}
function getDomainName() {
  var _a;
  return ((_a = getRuntimeConfig()) == null ? void 0 : _a.domainName) || "docs.qq.com";
}
var isSaasDemoEnv = function() {
  return getDomainName() === "qydocs.qq.com";
};
var isDesktop = function() {
  return location.pathname.indexOf("/desktop") === 0;
};
var isTmall = function() {
  return location.pathname.indexOf("/mall") === 0;
};
var isResume = function() {
  return location.pathname.indexOf("/resume") === 0;
};
function isToCHost() {
  var _a;
  return ((_a = getNormalConfig()) == null ? void 0 : _a.domain) === "toc";
}
function isPrivateEnv() {
  var _a;
  return ((_a = getNormalConfig()) == null ? void 0 : _a.domain) === "private-tdocs";
}
var isTestEnv = function() {
  var currentEnvId = getCookie("env_id") || "";
  var currentEnvName = getCookie("env_name") || "";
  return /^(uat|sit(-[0-9a-z]{8})?)$/.test(currentEnvId) && !/^(release|hotfix)\//i.test(currentEnvName);
};
function fail(reason) {
  throw err(reason);
}
function failAsync(reason) {
  return Promise.reject(err(reason));
}
function printError(method, error) {
  console.error(getErrorDetail(method, error));
}
function getErrorDetail(method, error) {
  return "[docs-login] " + method + " failed: " + ((error == null ? void 0 : error.stack) || (error == null ? void 0 : error.message) || error);
}
function err(reason) {
  return new Error("[docs-login] " + reason);
}
var ZZS_SUCCESS = 0;
var ZZS_FAILED = 1;
function reportSuccess(method, detail) {
  if (detail === void 0)
    detail = "";
  reportZZS(method, detail, ZZS_SUCCESS);
}
function reportFailure(method, detail) {
  if (detail === void 0)
    detail = "";
  reportZZS(method, detail, ZZS_FAILED);
}
function reportZZS(k7, k8, status) {
  try {
    if (hasSendBeacon()) {
      return;
    }
    if (isPrivateEnv()) {
      return;
    }
    var data = [["fc_login", "status", "docs-login/" + k7, status, [k8, getHrefPrefix()]]];
    var url = getZZSReportUrl() + "?datas=" + encodeURIComponent(JSON.stringify(data)) + "&version=0.9.24";
    navigator.sendBeacon(url);
  } catch (err2) {
    printError("report", err2);
  }
}
function reportError(method, error) {
  try {
    printError(method, error);
    reportFailure(method, typeof error === "string" ? error : "error");
    if (typeof aegis === "undefined") {
      return;
    }
    aegis.error(getErrorDetail(method, error));
  } catch (err2) {
    printError("reportError", err2);
  }
}
function getZZSReportUrl() {
  var _a, _b;
  return ((_b = (_a = getRuntimeConfig()) == null ? void 0 : _a.reportCgiMap) == null ? void 0 : _b.zzsReport) || "https://report.idqqimg.com/node_b/zzsreport";
}
var hasSendBeacon = function() {
  var result;
  return function() {
    if (result === void 0) {
      result = typeof navigator === "undefined" || !navigator.sendBeacon;
    }
    return result;
  };
}();
var getHrefPrefix = function() {
  var result;
  return function() {
    if (result === void 0) {
      var pathPrefixMatches = location.pathname.match(/^(\/.*?)(\/|$)/);
      result = location.hostname + ((pathPrefixMatches == null ? void 0 : pathPrefixMatches[1]) || "/");
    }
    return result;
  };
}();
function loadLibrary(name, cacKey, fallbackUrl) {
  return Promise.resolve().then(function() {
    var _a, _b;
    if (name in window) {
      return;
    }
    var url = ((_b = (_a = getRuntimeConfig()) == null ? void 0 : _a.library) == null ? void 0 : _b[cacKey]) || fallbackUrl;
    return loadScript(url);
  }).then(function() {
    return window[name];
  });
}
function loadScript(src) {
  return new Promise(function(resolve, reject) {
    var script = document.createElement("script");
    script.src = src;
    script.onload = function() {
      return resolve();
    };
    script.onerror = function() {
      return reject(new Error("Failed to load script"));
    };
    document.body.appendChild(script);
  });
}
function loadWXMiniProgramSDK() {
  return loadLibrary(
    "wx",
    "TENCENT_DOCS_LIBRARY__jweixin_1_6_0",
    "https://docs.gtimg.com/lib/js/jweixin_1_6_0.js"
  );
}
function loadQQMiniProgramSDK() {
  return loadLibrary(
    "qq",
    "TENCENT_DOCS_LIBRARY__qqjssdk_1_0_0",
    "https://docs.gtimg.com/lib/js/qqjssdk_1_0_0.js"
  );
}
function loadMQQ() {
  return loadLibrary(
    "mqq",
    "TENCENT_DOCS_LIBRARY__docs_qqapi",
    "https://docs.gtimg.com/lib/js/docs_qqapi-1e4364.js"
  );
}
function miniProgramLogin(options) {
  if (options === void 0)
    options = {};
  return doMiniProgramLogin(resolveOptions$2(options));
}
function doMiniProgramLogin(opt) {
  reportSuccess("login-mini-program");
  var url = "/pages/detail/detail?reason=pskey_error&url=" + encodeURIComponent(opt.successUrl);
  var rtkey = getQuery("rtkey");
  if (rtkey) {
    url += "&scene=" + rtkey;
  }
  var miniProgramLibPromise = ua.isQQMiniProgram(currentUserAgent) ? loadQQMiniProgramSDK() : loadWXMiniProgramSDK();
  return miniProgramLibPromise.then(function(miniProgramLib) {
    var _a;
    if (!((_a = miniProgramLib == null ? void 0 : miniProgramLib.miniProgram) == null ? void 0 : _a.reLaunch)) {
      fail("MissingJSSDK");
    }
    miniProgramLib.miniProgram.reLaunch({ url });
    return waitForNavigation();
  });
}
var HASH_SYMBOL = "#";
var SEARCH_SYMBOL = "?";
var QUERY_SYMBOL = "&";
function removeURLParametersWithoutHash(url, params) {
  var _a;
  var urlParts = url.split(SEARCH_SYMBOL);
  var querys = (_a = urlParts[1]) === null || _a === void 0 ? void 0 : _a.split(QUERY_SYMBOL);
  if (!querys) {
    return url;
  }
  var querysAfterRemoved = querys;
  params.forEach(function(param) {
    querys.forEach(function(queryParam) {
      if (queryParam.indexOf("".concat(param, "=")) === 0) {
        var index = querysAfterRemoved.indexOf(queryParam);
        querysAfterRemoved.splice(index, 1);
      }
    });
  });
  if (querysAfterRemoved.length === 0) {
    return urlParts[0];
  }
  urlParts[1] = querysAfterRemoved.join(QUERY_SYMBOL);
  return urlParts.join(SEARCH_SYMBOL);
}
function removeURLParameters(url) {
  var arguments$1 = arguments;
  var params = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    params[_i - 1] = arguments$1[_i];
  }
  var urlParts = url.split(SEARCH_SYMBOL);
  if (urlParts.length < 2 || params.length < 1) {
    return url;
  }
  if (url.includes(HASH_SYMBOL)) {
    var hashParts = url.split(HASH_SYMBOL);
    hashParts[0] = removeURLParametersWithoutHash(hashParts[0], params);
    return hashParts.join(HASH_SYMBOL);
  }
  return removeURLParametersWithoutHash(url, params);
}
function mobileFallbackLogin(options) {
  if (options === void 0)
    options = {};
  return doMobileFallbackLogin(resolveOptions$2(options));
}
function doMobileFallbackLogin(opt) {
  var successUrl = opt.successUrl;
  reportSuccess("login-mobile-fallback");
  if (getQuery("nojump") === "1") {
    successUrl = removeURLParameters(location.href, "nojump");
  }
  location.href = "/login.html?jump_url=" + encodeURIComponent(successUrl);
  return waitForNavigation();
}
function mobileQQLogin(options) {
  if (options === void 0)
    options = {};
  return doMobileQQLogin(resolveOptions$2(options));
}
function doMobileQQLogin(opt) {
  reportSuccess("login-qq");
  if (getQuery("nojump") === "1") {
    return loginCancelled();
  }
  return loadMQQ().then(function(mqq) {
    var updateLoginInfoRequest = new Promise(function(resolve) {
      return mqq.invoke("data", "updateLoginInfo", { key: "pskey" }, resolve);
    });
    var timeout = new Promise(function(resolve) {
      return setTimeout(resolve, 1e3);
    });
    return Promise.race([updateLoginInfoRequest, timeout]);
  }).then(function() {
    var deviceInfo = "dev_scene=qqh5&dev_name=" + getDevName() + "&dev_id=" + getDevId();
    location.replace("/api/user/qq/login?u=login&" + deviceInfo + "&redirect_uri=" + encodeURIComponent(opt.successUrl));
    return waitForNavigation();
  });
}
function getDevName() {
  var OSName = "";
  var OSVersion = "";
  if (ua.isAndroid()) {
    OSName = "Android";
    OSVersion = ua.getAndroidVersion();
  } else if (ua.isIOS()) {
    OSName = "iOS";
    OSVersion = ua.getIOSVersion();
  }
  return JSON.stringify({
    devName: OSName && OSVersion ? OSName + " " + OSVersion : "",
    OSName,
    OSVersion
  });
}
function getDevId() {
  var _a;
  return ((_a = document.cookie.split(";").map(function(cookie) {
    return cookie.trim();
  }).filter(function(cookie) {
    return cookie.startsWith("fingerprint=");
  }).pop()) == null ? void 0 : _a.split("=")[1]) || "";
}
var DOC_SID = "DOC_SID";
var SID = "SID";
var UID = "uid";
var TDOCS_UID = "TDOCS_UID";
var UID_KEY = "uid_key";
var TDOCS_UID_KEY = "TDOCS_UID_KEY";
function isLogin() {
  var _a;
  if (window.basicClientVars) {
    var ref = window.basicClientVars.userInfo;
    var uidSource = ref.uidSource;
    if ((isDesktop() || isTmall() || isResume()) && isToCHost() && uidSource === 3) {
      return false;
    }
    return !!((_a = window.basicClientVars.userInfo) == null ? void 0 : _a.tinyId);
  }
  var cookies = getRawCookies();
  return !!(getDocsSessionId(cookies) || getCookie(UID, cookies) && getCookie(UID_KEY, cookies) || getCookie(TDOCS_UID, cookies) && getCookie(TDOCS_UID_KEY, cookies));
}
function getDocsSessionId(cookies) {
  if (cookies === void 0)
    cookies = getRawCookies();
  return getCookie(DOC_SID, cookies) || getCookie(SID, cookies) || void 0;
}
function mobileTencentDocsLogin(options) {
  if (options === void 0)
    options = {};
  return doMobileTencentDocsLogin(resolveOptions$2(options));
}
function doMobileTencentDocsLogin(opt) {
  reportSuccess("login-mobile-tencent-docs");
  if (!ua.isTencentDocsAppVersionAboveOrEqual("3.0.0", currentUserAgent)) {
    return loginCancelled();
  }
  return loadMQQ().then(function(mqq) {
    if (sessionStorage.getItem(HAS_TRIED_LOGIN_KEY)) {
      sessionStorage.removeItem(HAS_TRIED_LOGIN_KEY);
      mqq.invoke("nav", "showLoginPage");
      return waitForNavigation();
    }
    var getAppCookiesRequest = new Promise(function(resolve) {
      return mqq.invoke("docx", "getAppCookies", {}, resolve);
    });
    return getAppCookiesRequest;
  }).then(function(data) {
    var cookies = data == null ? void 0 : data.cookies;
    var uid = getCookie(UID, cookies);
    var uidKey = getCookie(UID_KEY, cookies);
    var sid = getCookie(DOC_SID, cookies) || getCookie(SID, cookies) || void 0;
    if (sid || uid && uidKey) {
      uid && setCookie(UID, uid, void 0, "/", getDomainName());
      uidKey && setCookie(UID_KEY, uidKey, void 0, "/", getDomainName());
      sid && setCookie(DOC_SID, sid, void 0, "/", getDomainName());
      sid && setCookie(SID, sid, void 0, "/", getDomainName());
      sessionStorage.setItem(HAS_TRIED_LOGIN_KEY, "1");
      setTimeout(function() {
        location.replace(opt.successUrl);
      });
      return waitForNavigation();
    } else {
      return loadMQQ().then(function(mqq) {
        mqq.invoke("nav", "showLoginPage");
        return waitForNavigation();
      });
    }
  });
}
var HAS_TRIED_LOGIN_KEY = "docs-login-app-has-tried-login";
function resolveExternalAsyncDependency(dep) {
  return Promise.resolve(dep).then(function(depOrGetter) {
    if (typeof depOrGetter === "function") {
      return depOrGetter();
    }
    return depOrGetter;
  });
}
function resolveExtensionService(extensionServiceGetter) {
  return resolveExternalAsyncDependency(extensionServiceGetter || getGlobalExtensionService);
}
function resolveAccountApplication(accountApplicationGetter) {
  return resolveExternalAsyncDependency(accountApplicationGetter || getGlobalExtensionService).then(function(value) {
    return "getExtension" in value ? value.dependentServiceCombinder.accountApplication : value;
  });
}
function hasGlobalExtensionService() {
  return !!window.__ARK_EXTENSION_SERVICE__;
}
function getGlobalExtensionService() {
  var extensionService = window.__ARK_EXTENSION_SERVICE__;
  if (!extensionService) {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("\u5F53\u524D\u6D41\u7A0B\u9700\u8981\u4F7F\u7528\u5230 ExtensionService, \u4F46\u65E0\u6CD5\u5728\u5168\u5C40\u4F5C\u7528\u57DF\u4E2D\u627E\u5230. \u8BF7\u786E\u8BA4 ExtensionService \u7684\u5B9E\u4F8B\u5316\u4E0E\u767B\u5F55\u4EE3\u7801\u7684\u6267\u884C\u987A\u5E8F, \u6216\u662F\u4E3B\u52A8\u4F20\u5165 ExtensionService.");
    } else {
      fail("MissingExtensionService");
    }
  }
  return extensionService;
}
function injectUserInfo(extensionService, userInfo) {
  var ref = extensionService.dependentServiceCombinder.accountDomain;
  var accountAggregate = ref.accountAggregate;
  accountAggregate.userInfo.jsonObj2Class(userInfo, true);
}
function initAccountApplication(accountApplication, userInfo) {
  return resolveAccountApplication(accountApplication).then(function(accountApplication2) {
    var accountDomainService = accountApplication2.accountDomainService;
    var loginDomainService = accountApplication2.loginDomainService;
    accountDomainService.createPersonalEnvAccountAggregateByUserInfoCgi(userInfo, userInfo.nowUserIndex);
    loginDomainService.createLoginAggregate(userInfo.tinyId);
    accountApplication2.initDomainService();
    accountApplication2.isInitFinish = true;
  }).catch(function(err2) {
    reportError("initAccountApplication", err2);
  });
}
var ON_DEMAND = 3;
function loadExtension(extensionServiceGetter, descriptor) {
  return resolveExtensionService(extensionServiceGetter).then(function(extensionService) {
    return extensionService.scanAndHandleExtensions([descriptor]).then(function() {
      return extensionService.getExtension(descriptor.name);
    });
  });
}
function loadLoginDialog(extensionServiceGetter) {
  return loadExtension(extensionServiceGetter, {
    name: "docs-component-login",
    loadType: ON_DEMAND
  });
}
function loadLoginButtonMobile(extensionServiceGetter) {
  return loadExtension(extensionServiceGetter, {
    name: "docs-component-login-button-mobile",
    loadType: ON_DEMAND
  });
}
function loadIndependentPasswordMobile(extensionServiceGetter) {
  return loadExtension(extensionServiceGetter, {
    name: "docs-component-independent-pwd-mobile",
    loadType: ON_DEMAND
  });
}
function pcLogin(options) {
  if (options === void 0)
    options = {};
  return doPCLogin(resolveOptions$2(options));
}
function doPCLogin(opt) {
  reportSuccess("login-pc");
  return loadLoginDialog(opt.extensionService).then(function(loginDialog) {
    return new Promise(function(resolve) {
      var cancellable = opt.cancellable;
      var useQQOAuth = opt.useQQOAuth;
      var useWechatOfficialAccount = opt.useWechatOfficialAccount;
      loginDialog.show({
        usageScenario: cancellable ? "OPEN_LOGIN_BOX" : "OPEN_FULL_LOGIN_BOX",
        fullscreenMode: !cancellable,
        isShowCloseBtn: cancellable,
        closeBoxCallback: function() {
          return resolve(loginCancelled());
        },
        useQQOAuth,
        useWechatOfficialAccount
      });
    });
  });
}
function wechatLogin(options) {
  if (options === void 0)
    options = {};
  return doWechatLogin(resolveOptions$2(options));
}
function doWechatLogin(opt) {
  reportSuccess("login-wechat", "start");
  return showWechatLoginAgreement(opt).then(function(agreed) {
    if (!agreed) {
      reportSuccess("login-wechat", "cancelled");
      return loginCancelled();
    }
    reportSuccess("login-wechat", "oauth");
    return goWechatOAuth(opt);
  });
}
function showWechatLoginAgreement(opt) {
  return loadLoginButtonMobile(opt.extensionService).then(function(ref) {
    var renderPopup = ref.renderPopup;
    return new Promise(function(resolve) {
      var onConfirmAgreement = function() {
        return resolve(true);
      };
      var onCancel = function() {
        return resolve(false);
      };
      renderPopup(onConfirmAgreement, onCancel).showPopup(0, opt.cancellable);
    });
  });
}
function goWechatOAuth(opt) {
  var appId = "wx46dfe750eef96da7";
  var redirectUrl = "https://" + getDomainName() + "/scenario/wx-login.html?target=" + encodeURIComponent(opt.successUrl);
  var query = "appid=" + appId + "&redirect_uri=" + encodeURIComponent(redirectUrl) + "&response_type=code&scope=snsapi_userinfo&state=onweixinlogin";
  var url = "https://open.weixin.qq.com/connect/oauth2/authorize?" + query + "#wechat_redirect";
  location.replace(url);
  return waitForNavigation();
}
function weworkLogin(options) {
  if (options === void 0)
    options = {};
  return doWeworkLogin(resolveOptions$2(options));
}
function doWeworkLogin(opt) {
  reportSuccess("login-wework");
  var appId = "ww20388f7040b655b7";
  var redirectUrl = "https://" + getDomainName() + "/api/account/wecom/login?u=login&redirect_uri=" + encodeURIComponent(opt.successUrl);
  var query = "appid=" + appId + "&redirect_uri=" + encodeURIComponent(redirectUrl) + "&response_type=code&scope=snsapi_userinfo&state=weworklogin";
  var url = "https://open.weixin.qq.com/connect/oauth2/authorize?" + query + "#wechat_redirect";
  location.replace(url);
  return waitForNavigation();
}
function logout() {
  clearCookie();
}
function clearCookie() {
  var domain = getDomainName();
  delCookie(DOC_SID, "/", domain);
  delCookie(SID, "/", domain);
  delCookie(UID, "/", domain);
  delCookie(UID_KEY, "/", domain);
  delCookie(TDOCS_UID, "/", domain);
  delCookie(TDOCS_UID_KEY, "/", domain);
}
function doEidLogin(opt) {
  reportSuccess("login-eid");
  logout();
  location.replace(opt.successUrl);
  return waitForNavigation();
}
function doSaasDemoLogin() {
  location.replace("https://" + getDomainName() + "/scenario/enterprise-experience-entry.html");
  return waitForNavigation();
}
const __assign = Object.assign;
function lowerCase(str) {
  return str.toLowerCase();
}
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  while (result.charAt(start) === "\0") {
    start++;
  }
  while (result.charAt(end - 1) === "\0") {
    end--;
  }
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
function replace(input, re, value) {
  if (re instanceof RegExp) {
    return input.replace(re, value);
  }
  return re.reduce(function(input2, re2) {
    return input2.replace(re2, value);
  }, input);
}
function pascalCaseTransform(input, index) {
  var firstChar = input.charAt(0);
  var lowerChars = input.substr(1).toLowerCase();
  if (index > 0 && firstChar >= "0" && firstChar <= "9") {
    return "_" + firstChar + lowerChars;
  }
  return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign({ delimiter: "", transform: pascalCaseTransform }, options));
}
function camelCaseTransform(input, index) {
  if (index === 0) {
    return input.toLowerCase();
  }
  return pascalCaseTransform(input, index);
}
function camelCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return pascalCase(input, __assign({ transform: camelCaseTransform }, options));
}
var isObject$1 = function(value) {
  return typeof value === "object" && value !== null;
};
var isObjectCustom = function(value) {
  return isObject$1(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date) && !(globalThis.Blob && value instanceof globalThis.Blob);
};
var mapObjectSkip = Symbol("mapObjectSkip");
var _mapObject = function(object, mapper, options, isSeen) {
  if (isSeen === void 0)
    isSeen = /* @__PURE__ */ new WeakMap();
  options = Object.assign(
    {},
    {
      deep: false,
      target: {}
    },
    options
  );
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  var target = options.target;
  delete options.target;
  var mapArray = function(array) {
    return array.map(function(element) {
      return isObjectCustom(element) ? _mapObject(element, mapper, options, isSeen) : element;
    });
  };
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (var i = 0, list = Object.entries(object); i < list.length; i += 1) {
    var ref = list[i];
    var key = ref[0];
    var value = ref[1];
    var mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip) {
      continue;
    }
    var newKey = mapResult[0];
    var newValue = mapResult[1];
    var mapResult_2 = mapResult[2];
    if (mapResult_2 === void 0)
      mapResult_2 = {};
    var shouldRecurse = mapResult_2.shouldRecurse;
    if (shouldRecurse === void 0)
      shouldRecurse = true;
    if (newKey === "__proto__") {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : _mapObject(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
function mapObject(object, mapper, options) {
  if (!isObject$1(object)) {
    throw new TypeError("Expected an object, got `" + object + "` (" + typeof object + ")");
  }
  if (Array.isArray(object)) {
    throw new TypeError("Expected an object, got an array");
  }
  return _mapObject(object, mapper, options);
}
function camelize(input) {
  if (!isObject(input)) {
    return input;
  }
  if (Array.isArray(input)) {
    return input.map(camelize);
  }
  return mapObject(input, function(key, value) {
    return [camelCase(key), camelize(value)];
  });
}
function isObject(value) {
  return typeof value === "object" && value !== null;
}
function getUid() {
  return getUidFromBasicClientVars() || getUidFromCookie() || getUidFromGlobalMultiUser() || getUidFromClientVars();
}
function getUidFromBasicClientVars() {
  var _a;
  return (_a = window.basicClientVars) == null ? void 0 : _a.userInfo.tinyId;
}
function getUidFromCookie() {
  var _a, _b, _c;
  return ((_c = (_b = (_a = getNormalConfig()) == null ? void 0 : _a.npm) == null ? void 0 : _b["@tencent/docs-login"]) == null ? void 0 : _c.USE_TDOCS_UID) ? getCookie(TDOCS_UID) : getCookie(UID);
}
function getUidFromGlobalMultiUser() {
  var _a;
  return (_a = window.global_multi_user) == null ? void 0 : _a.uid;
}
function getUidFromClientVars() {
  var _a;
  var ref = ((_a = window.clientVars) == null ? void 0 : _a.userInfo) || {};
  var tinyId = ref.tinyId;
  var uid = ref.uid;
  return tinyId || uid;
}
function getUidKey() {
  return getUidKeyFromCookie();
}
function getUidKeyFromCookie() {
  var _a, _b, _c;
  return ((_c = (_b = (_a = getNormalConfig()) == null ? void 0 : _a.npm) == null ? void 0 : _b["@tencent/docs-login"]) == null ? void 0 : _c.USE_TDOCS_UID) ? getCookie(TDOCS_UID_KEY) : getCookie(UID_KEY);
}
function getNowUserIndex() {
  var _a;
  return window.nowUserIndex || ((_a = window.basicClientVars) == null ? void 0 : _a.userInfo.nowUserIndex) || getQuery("u");
}
function getUserInfo() {
  if (!isLogin()) {
    return;
  }
  return doGetUserInfo();
}
function doGetUserInfo() {
  return getUserInfoFromBasicClientVars() || getEmptyUserInfo();
}
function getEmptyUserInfo() {
  var uid = getUid() || "";
  var nowUserIndex = getNowUserIndex() || "";
  return Object.assign(
    {},
    placeholderUserInfo,
    {
      uid,
      corpId: "",
      corpName: "",
      englishName: "",
      loginType: 0,
      login: true,
      uin: "0",
      uidSource: 0,
      wxOpenid: "",
      openId: "",
      tinyid: uid,
      tinyId: uid,
      userId: uid,
      avatar: "",
      userPic: "",
      nick: "",
      userName: "",
      toid: uid,
      xu: nowUserIndex,
      nowUserIndex
    }
  );
}
function getUserInfoFromBasicClientVars() {
  if (!getUidFromBasicClientVars()) {
    return;
  }
  var ref = window.basicClientVars;
  var userInfo = ref.userInfo;
  var tinyId = userInfo.tinyId;
  var corpId = userInfo.corpId || "";
  var corpName = userInfo.corpName || "";
  var englishName = userInfo.englishName || "";
  var loginType = userInfo.loginType || 0;
  var uin = userInfo.uin || "0";
  var uidSource = userInfo.uidSource || 0;
  var openId = userInfo.openId || "";
  var userPic = userInfo.userPic || "";
  var userName = userInfo.userName || "";
  var nowUserIndex = userInfo.nowUserIndex || "";
  return Object.assign(
    {},
    placeholderUserInfo,
    {
      uid: tinyId,
      corpId,
      corpName,
      englishName,
      loginType,
      login: !!tinyId,
      uin,
      uidSource,
      wxOpenid: openId,
      openId,
      tinyid: tinyId,
      tinyId,
      userId: tinyId,
      avatar: userPic,
      userPic,
      nick: userName,
      userName,
      toid: tinyId,
      xu: nowUserIndex,
      nowUserIndex,
      wechatOfficialAccount: userInfo.officialAuthInfo ? Object.assign({}, userInfo.officialAuthInfo, { isOfficialAccount: true }) : placeholderUserInfo.wechatOfficialAccount
    }
  );
}
function fetchUserInfo(userIndex) {
  if (userIndex === void 0)
    userIndex = getNowUserIndex();
  return sendUserInfoRequest(userIndex, "get_vip_info=1").then(function(ref) {
    var rsp = ref[0];
    var xhr = ref[1];
    if (isAuthenticationFailureCode(rsp.retcode)) {
      return void 0;
    }
    if (rsp.retcode !== 0) {
      return failAsync("FetchUserInfoFailed");
    }
    return getUserInfoFromApiResponse(rsp, xhr.getResponseHeader("x-u") || userIndex);
  });
}
function getUserInfoFromApiResponse(rsp, _u) {
  var nowUserIndex = getNowUserIndex() || "";
  var vip = function(vipInfo) {
    try {
      return camelize(JSON.parse(vipInfo));
    } catch (e) {
      return null;
    }
  }(rsp.vip);
  return Object.assign(
    {},
    camelize(rsp),
    {
      vip,
      uin: String(rsp.uin),
      tinyId: rsp.tinyid,
      openId: rsp.wx_openid,
      userName: rsp.nick,
      userPic: rsp.avatar,
      xu: nowUserIndex,
      nowUserIndex
    }
  );
}
var placeholderUserInfo = {
  qqAvatar: "",
  qqNick: "",
  wxAvatar: "",
  wxNick: "",
  domain: "",
  domainId: "",
  loginTime: 0,
  vip: {
    vipLevel: 0,
    avatarFrameUrl: "",
    renewalStatus: 0,
    expiredStatus: 0,
    corpVipLevel: 0,
    cursorId: "",
    cursor: "",
    badgeUrl: ""
  },
  wechatOfficialAccount: {
    avatar: "",
    nick: "",
    introduction: "",
    type: 0,
    principal: "",
    credential: "",
    isOfficialAccount: false
  }
};
function checkLogin(userIndex) {
  if (userIndex === void 0)
    userIndex = getNowUserIndex();
  if (!isLogin()) {
    return Promise.resolve(false);
  }
  return sendUserInfoRequest(userIndex, "only_check=1").then(function(ref) {
    var rsp = ref[0];
    return rsp.retcode === 0;
  });
}
function sendUserInfoRequest(userIndex, body) {
  var url = "/cgi-bin/online_docs/user_info?xsrf=" + getXSRF() + "&" + body;
  if (userIndex) {
    url += "&u=" + encodeURIComponent(userIndex);
  }
  return get(url);
}
function post(url, body, options) {
  var defaultOptions = {
    header: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  };
  var reqOptions = Object.assign({}, defaultOptions, options);
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    var contentType = reqOptions.header["Content-Type"];
    xhr.open("POST", appendUserIndex(url));
    xhr.setRequestHeader("Content-Type", contentType);
    xhr.timeout = 3e3;
    xhr.onabort = reject;
    xhr.onerror = reject;
    xhr.ontimeout = reject;
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) {
        return;
      }
      try {
        var response = JSON.parse(xhr.responseText);
        resolve([response, xhr]);
      } catch (e) {
        reportError("post", new SyntaxError(xhr.responseText));
        reject(e);
      }
    };
    if (!body) {
      xhr.send();
    } else if (contentType === "application/json") {
      xhr.send(JSON.stringify(body));
    } else {
      xhr.send("xsrf=" + getXSRF() + "&" + body);
    }
  });
}
function get(url) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", appendUserIndex(url));
    xhr.onabort = reject;
    xhr.onerror = reject;
    xhr.ontimeout = reject;
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) {
        return;
      }
      try {
        var response = JSON.parse(xhr.responseText);
        resolve([response, xhr]);
      } catch (e) {
        reject(e);
      }
    };
    xhr.send();
  });
}
function appendUserIndex(url) {
  if (/[&?]u=/.test(url)) {
    return url;
  }
  var u = "u=" + (getNowUserIndex() || "");
  var delimiter = url.indexOf("?") >= 0 ? "&" : "?";
  return url + delimiter + u;
}
function isAuthenticationFailureCode(code) {
  return code === 11e3 || code === 12100 || code === 11005 || code === 12105 || code === 11006;
}
function addURLParams(url, parameters) {
  for (var key in parameters) {
    if (Object.prototype.hasOwnProperty.call(parameters, key)) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var value = parameters[key];
      var separator = url.indexOf("?") !== -1 ? "&" : "?";
      if (url.match(re)) {
        url = url.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        url = url + separator + key + "=" + value;
      }
    }
  }
  return url;
}
var SaaSTdocsOrigin = "https://saas.docs.qq.com";
var SaaSAccountDomain = !isTestEnv() ? "account.tencent.com" : "ci-756.account.tencentcs.com";
var SaaSWorkspaceDomain = !isTestEnv() ? "workspace.tencent.com" : "ci-756.workspace.tencentcs.com";
var SaaSAuthorizeURL = !isTestEnv() ? "//oauth2.account.tencent.com/v1/authorize" : "//oauth2.ci-756.account.tencentcs.com/v1/authorize";
var SaaSTdocsClientId = !isTestEnv() ? "ZHedOjkJuhiGQYbEjBshoehx" : "cXCIqAyyINIOLhZXWkZvKRGj";
var openSaaSAuthorizePage = function(option) {
  var ref = option || {};
  var target_link_uri = ref.target_link_uri;
  if (target_link_uri === void 0)
    target_link_uri = "";
  var saasLoginCallbackPage = SaaSTdocsOrigin + "/scenario/saas-login-callback";
  var redirectURI = addURLParams(saasLoginCallbackPage, target_link_uri ? { target_link_uri } : {});
  var targetURL = addURLParams(SaaSAuthorizeURL, {
    client_id: SaaSTdocsClientId,
    response_type: "code",
    redirect_uri: encodeURIComponent(redirectURI),
    scope: "openid profile offline_access"
  });
  location.replace(targetURL);
  return;
};
var openSaaSAccountCenter = function() {
  var SaaSAccountCenterURL = "//" + SaaSAccountDomain + "/#/profile";
  window.open(SaaSAccountCenterURL);
  return;
};
var openSaaSAdminCenter = function() {
  var SaaSAdminURL = "//" + SaaSWorkspaceDomain + "/admin/#/users";
  window.open(SaaSAdminURL);
  return;
};
var openSaaSTdocsServiceAgreement = function() {
  var saasTdocsServiceAgreementURL = "https://docs.qq.com/doc/p/8c9b7590b5484c7532c636a1011da1d915829ac8";
  window.open(saasTdocsServiceAgreementURL);
  return;
};
var openSaaSTdocsPrivacyPolicy = function() {
  var saasTdocsPrivacyPolicyURL = "https://docs.qq.com/doc/p/198d55cb4f92b4acb5c9d82c060ab65bebe8a4db";
  window.open(saasTdocsPrivacyPolicyURL);
  return;
};
var doSaaSLogin = function(options) {
  var successUrl = options.successUrl;
  if (successUrl === void 0)
    successUrl = "";
  openSaaSAuthorizePage({ target_link_uri: successUrl });
  return waitForNavigation();
};
function login(options) {
  if (options === void 0)
    options = {};
  return withLoginReport("login", function() {
    return doLogin(resolveOptions$2(options));
  });
}
function doLogin(opt) {
  var _a, _b, _c;
  if (isSaasDemoEnv()) {
    return doSaasDemoLogin();
  }
  if (((_a = getNormalConfig()) == null ? void 0 : _a.domain) === "saas-tdocs") {
    return doSaaSLogin(opt);
  }
  if ((_c = (_b = getNormalConfig()) == null ? void 0 : _b.npm["@tencent/docs-login"]) == null ? void 0 : _c.DO_EID_LOGIN) {
    return doEidLogin(opt);
  }
  if (ua.isTencentDocsApp(currentUserAgent)) {
    return doMobileTencentDocsLogin(opt);
  }
  if (ua.isMiniProgram(currentUserAgent)) {
    return doMiniProgramLogin(opt);
  }
  if (ua.isWeChat(currentUserAgent)) {
    return doWechatLogin(opt);
  }
  if (ua.isWxWork(currentUserAgent) && !ua.isWxWorkPrivate(currentUserAgent)) {
    var shouldSkipWeworkLogin = (isDesktop() || isTmall()) && isToCHost();
    if (!shouldSkipWeworkLogin) {
      return doWeworkLogin(opt);
    }
  }
  if (ua.isTimOrQQ(currentUserAgent)) {
    return doMobileQQLogin(opt);
  }
  if (ua.isMobilePhone(currentUserAgent)) {
    return doMobileFallbackLogin(opt);
  }
  return doPCLogin(opt);
}
function loginOnce(options) {
  if (options === void 0)
    options = {};
  if (!loginOnce.req) {
    loginOnce.req = login(options).then(function(result) {
      loginOnce.req = null;
      return result;
    });
  }
  return loginOnce.req;
}
loginOnce.req = null;
function autoLogin(options) {
  if (options === void 0)
    options = {};
  return withLoginReport("autoLogin", function() {
    return doAutoLogin(resolveOptions$2(options));
  });
}
function doAutoLogin(opt) {
  if (ua.isWeChat(currentUserAgent)) {
    return doWechatLogin(opt);
  }
  if (ua.isWxWork(currentUserAgent) && !ua.isWxWorkPrivate(currentUserAgent)) {
    return doWeworkLogin(opt);
  }
  return loginCancelled();
}
function resolveOptions$2(options) {
  var _a, _b, _c;
  return {
    extensionService: options.extensionService,
    cancellable: (_a = options.cancellable) != null ? _a : true,
    successUrl: options.successUrl || location.href,
    useQQOAuth: (_b = options.useQQOAuth) != null ? _b : false,
    useWechatOfficialAccount: (_c = options.useWechatOfficialAccount) != null ? _c : false
  };
}
function waitForNavigation() {
  return new Promise(function() {
  });
}
function loginCancelled() {
  return Promise.resolve({ cancelled: true });
}
function withLoginReport(method, fn) {
  reportSuccess(method, "start");
  return Promise.resolve().then(fn).then(function(result) {
    reportSuccess(method, "done");
    return result;
  }).catch(function(err2) {
    reportError(method, err2);
    throw err2;
  });
}
function authenticate(options) {
  if (options === void 0)
    options = {};
  reportSuccess("authenticate", "start");
  return Promise.resolve().then(function() {
    return doAuthenticate(resolveOptions$1(options));
  }).then(function(userInfo) {
    var isLogin2 = !!userInfo;
    reportSuccess("authenticate", getLoginState(isLogin2));
    return userInfo;
  }).catch(function(err2) {
    reportError("authenticate", err2);
    return void 0;
  });
}
function doAuthenticate(opt) {
  var isLogin$1 = isLogin();
  if (!isLogin$1 && !opt.login) {
    return void 0;
  }
  return Promise.resolve().then(function() {
    if (!isLogin$1) {
      reportSuccess("authenticate", "login");
      var ref = opt.login;
      var login2 = ref[0];
      var loginOptions = ref[1];
      login2(loginOptions).catch(function() {
        return reportFailure("authenticate", "login");
      });
      return void 0;
    }
    if (opt.fetchUserInfo) {
      return fetchUserInfo();
    }
    return doGetUserInfo();
  }).then(function(userInfo) {
    if (userInfo && opt.fetchUserInfo && opt.accountApplication !== false) {
      return initAccountApplication(opt.accountApplication, userInfo).then(function() {
        return userInfo;
      });
    }
    return userInfo;
  });
}
function resolveOptions$1(options) {
  var _a;
  return {
    login: resolveLoginOption(options),
    fetchUserInfo: (_a = options.fetchUserInfo) != null ? _a : !("basicClientVars" in window),
    accountApplication: options.accountApplication !== void 0 ? options.accountApplication : hasGlobalExtensionService() ? void 0 : false
  };
}
function resolveLoginOption(options) {
  if (getQuery("nologin") === "1") {
    return void 0;
  }
  var shouldLogin = options.login || options.login === void 0 && getQuery("autoshowlogin") === "1";
  if (shouldLogin) {
    return [login, toLoginOptions(options.login)];
  }
  if (options.autoLogin === false) {
    return void 0;
  }
  if (options.autoLogin === void 0 && !hasGlobalExtensionService()) {
    return void 0;
  }
  return [autoLogin, toLoginOptions(options.autoLogin)];
}
function toLoginOptions(input) {
  return typeof input === "object" ? input : void 0;
}
function getLoginState(isLogin2) {
  return isLogin2 ? "logged-in" : "not-logged-in";
}
function authenticateIndependentPassword(options) {
  if (options === void 0)
    options = {};
  reportSuccess("authenticateIndependentPassword", "start");
  return doAuthenticateIndependentPassword(options).catch(function(err2) {
    reportError("authenticateIndependentPassword", err2);
    return false;
  });
}
function doAuthenticateIndependentPassword(options) {
  return isIndependentPasswordTokenValid().then(function(valid) {
    if (!valid) {
      reportSuccess("authenticateIndependentPassword", "requestIndependentPassword");
      return requestIndependentPassword(options);
    }
    reportSuccess("authenticateIndependentPassword", "valid");
    return true;
  });
}
function isIndependentPasswordTokenValid() {
  reportSuccess("isIndependentPasswordTokenValid", "start");
  if (!isLogin()) {
    reportFailure("isIndependentPasswordTokenValid", "not-logged-in");
    return failByUserNotLoggedIn();
  }
  return post("/cgi-bin/online_docs/doclist", "list_type=59184").then(
    function(ref) {
      var retcode = ref[0].retcode;
      if (isAuthenticationFailureCode(retcode)) {
        reportFailure("isIndependentPasswordTokenValid", "not-logged-in");
        return failByUserNotLoggedIn();
      }
      var result = retcode !== 20062;
      reportSuccess("isIndependentPasswordTokenValid", result ? "valid" : "invalid");
      return result;
    },
    function(err2) {
      reportError("isIndependentPasswordTokenValid", err2);
      return true;
    }
  );
}
function requestIndependentPassword(options) {
  if (options === void 0)
    options = {};
  if (!isLogin()) {
    reportFailure("requestIndependentPassword", "not-logged-in");
    return failByUserNotLoggedIn();
  }
  var opt = resolveOptions(options);
  var doRequest = ua.isMobile() ? requestIndependentPasswordMobile : requestIndependentPasswordPc;
  return doRequest(opt).catch(function(err2) {
    reportError("requestIndependentPassword", err2);
    throw err2;
  });
}
function resolveOptions(options) {
  return Object.assign(
    {},
    options,
    { successUrl: options.successUrl || location.href }
  );
}
function requestIndependentPasswordPc(opt) {
  var tasks = Promise.all([
    loadLoginDialog(opt.extensionService),
    resolveExtensionService(opt.extensionService),
    ensureValidUserInfo(opt.userInfo)
  ]);
  return tasks.then(function(ref) {
    var loginDialog = ref[0];
    var extensionService = ref[1];
    var ref_2 = ref[2];
    var nick = ref_2.nick;
    var avatar = ref_2.avatar;
    injectUserInfo(extensionService, { userName: nick, userPic: avatar });
    loginDialog.show({ usageScenario: "OPEN_FULL_LOGIN_FOR_PASSWORD" });
    return waitForNavigation();
  });
}
function requestIndependentPasswordMobile(opt) {
  var tasks = Promise.all([
    loadIndependentPasswordMobile(opt.extensionService),
    ensureValidUserInfo(opt.userInfo)
  ]);
  return tasks.then(function(ref) {
    var independentPasswordMobile = ref[0];
    var userInfo = ref[1];
    independentPasswordMobile.show({
      userInfo,
      isDesktop: true,
      successUrl: opt.successUrl
    });
    Object.assign(independentPasswordMobile.container.style, {
      position: "fixed",
      left: "0",
      top: "0",
      width: "100vw",
      height: "100vh",
      zIndex: "999999"
    });
    return waitForNavigation();
  });
}
function ensureValidUserInfo(userInfoInput) {
  var userInfoReq = userInfoInput || getUserInfo();
  if (!(userInfoReq == null ? void 0 : userInfoReq.nick) || !userInfoReq.avatar) {
    userInfoReq = fetchUserInfo();
  }
  return Promise.resolve(userInfoReq).then(function(userInfo) {
    if (!userInfo) {
      return failByUserNotLoggedIn();
    }
    return userInfo;
  });
}
function failByUserNotLoggedIn() {
  return failAsync("UserIsNotLoggedIn");
}
function doEidLogout() {
  var baseURL = "https://" + getDomainName() + "/api/enterprise/account/logout";
  var logoutURL = addURLParams(baseURL, {
    redirect_uri: encodeURIComponent(location.href),
    xsrf: getXSRF() || ""
  });
  location.replace(logoutURL);
  return Promise.resolve(true);
}
function isEidAdmin() {
  var url = "//" + getDomainName() + "/api/enterprise/relationship/contacts/role?xsrf=" + getXSRF();
  return post(url, null, {
    header: {
      "Content-Type": "application/json"
    }
  }).then(function(ref) {
    var res = ref[0];
    var _a;
    if (res == null ? void 0 : res.retcode) {
      return false;
    }
    if ((_a = res == null ? void 0 : res.result) == null ? void 0 : _a.is_admin) {
      return true;
    }
    return false;
  });
}
var openPrivateAccountCenter = function() {
  var SaaSAccountCenterURL = "https://" + getDomainName() + "/eid/idp/#/profile";
  window.open(SaaSAccountCenterURL);
  return;
};
var openPrivateAdminCenter = function() {
  var SaaSAdminURL = "https://" + getDomainName() + "/eid/admin";
  window.open(SaaSAdminURL);
  return;
};
export {
  authenticate,
  authenticateIndependentPassword,
  autoLogin,
  checkLogin,
  doEidLogout,
  fetchUserInfo,
  getNowUserIndex,
  getUid,
  getUidFromCookie,
  getUidKey,
  getUserInfo,
  isAuthenticationFailureCode,
  isEidAdmin,
  isIndependentPasswordTokenValid,
  isLogin,
  isTestEnv,
  loadScript,
  loadWXMiniProgramSDK,
  login,
  loginOnce,
  logout,
  miniProgramLogin,
  mobileFallbackLogin,
  mobileQQLogin,
  mobileTencentDocsLogin,
  openPrivateAccountCenter,
  openPrivateAdminCenter,
  openSaaSAccountCenter,
  openSaaSAdminCenter,
  openSaaSAuthorizePage,
  openSaaSTdocsPrivacyPolicy,
  openSaaSTdocsServiceAgreement,
  pcLogin,
  requestIndependentPassword,
  wechatLogin,
  weworkLogin
};
//# sourceMappingURL=docs-login.esm.js.map
